module.exports = __webpack_public_path__ + "img/cel_bg.65c30ea7.jpg";